const SET_LOADED_IMAGES_SECTION = 'loadedImages/SET_LOADED_IMAGES_SECTION';

const initialState = {
  sections: [],
};

const reducer = function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOADED_IMAGES_SECTION:
      let newState = { ...state };
      if (!newState.sections.includes(action.sectionID)) {
        newState.sections = newState.sections.slice();
        newState.sections.push(action.sectionID);
      }
      return newState;
    default:
      return state;
  }
};

export function setLoadedImagesSection(sectionID) {
  return { type: SET_LOADED_IMAGES_SECTION, sectionID };
}

/**
 * Sagas
 */
function* setupSagas() {}

/** ***********************************************************************
 *  Main Export
 *  *********************************************************************** */
export default {
  reducer: reducer,
  saga: setupSagas,
};
